<script lang="ts">
import StationPickerStation from "./StationPickerStation.vue";
export default StationPickerStation;
</script>
